import { Skeleton } from '@mui/material';

export const AIFileNameSuggestionsLoadingState = () => (
  <>
    <Skeleton height={50} aria-label="Loading file name suggestion" />
    <Skeleton height={50} aria-label="Loading file name suggestion" />
    <Skeleton height={50} aria-label="Loading file name suggestion" />
  </>
);
